import {
  Card,
  CardActions,
  CardContent,
  CardHeader,
  CardMedia,
  Stack,
} from "@mui/material";
import { UpgradeSubscriptionButton } from "components/action-buttons/action-buttons";

interface AccessControlModalProps {
  title: string;
  children?: React.ReactNode;
  image: string;
}

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  width: "650px",
  p: 1,
  display: "flex",
  flexDirection: "column",
};

export const AccessControlModal = (props: AccessControlModalProps) => {
  return (
    <Card sx={style}>
      <CardHeader title={props.title}></CardHeader>
      <CardContent>
        <Stack direction="row" spacing={1}>
          {props?.children}
          <CardMedia
            sx={{ height: 250, width: 250 }}
            component="img"
            src={props.image}
          />
        </Stack>
      </CardContent>
      <CardActions style={{ justifyContent: "flex-end", flexGrow: 1 }}>
        <UpgradeSubscriptionButton
          variant="contained"
          text="See Subscriptions"
          size="small"
        />
      </CardActions>
    </Card>
  );
};
